module.exports = __webpack_public_path__ + "static/media/x-ambientworks.6427bd5.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ambient-works/x-ambientworks.mp3
// module id = pZLw
// module chunks = 0